import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxTxTimelineChartComponent } from './rx-tx-timeline-chart.component';

@NgModule({
    imports: [CommonModule],
    declarations: [RxTxTimelineChartComponent],
    exports: [RxTxTimelineChartComponent],
})
export class UiRxTxTimelineChartModule {}
